<template>
  <modal
    elem-id="modal_peg_override"
    :title="t('Definir peg da franquia')"
    :show="isVisible"
    size="small"
    :close-label="t('Cancelar')"
    :save-label="t('Salvar')"
    :save-fn="handleSave"
    save-test-id="peg-override-submit"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <peg-override-form
      v-if="isVisible"
      ref="formRef"
      :franquia-id="franquiaId"
      @saved="closeModal"
    />
  </modal>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../../eventBus'
import { log } from '../../../utils/DebugLogger'
import Modal from '../../../ui/Modal.vue'
import PegOverrideForm from './PegOverrideForm.vue'

/**
 * Opened via eventBus (`modal.pegOverride.open`), never by ref — the platform
 * convention. Registered once in ModalManager.
 *
 * The payload MAY carry a franquiaId to pre-select (opening from a franchise's
 * own row); without it the form asks for one.
 */
interface OpenPayload {
  franquiaId?: number
}

const { t } = useI18n()

const isVisible = ref(false)
const franquiaId = ref<number | null>(null)
const formRef = ref<InstanceType<typeof PegOverrideForm> | null>(null)

function openModal(payload?: OpenPayload): void {
  franquiaId.value = payload?.franquiaId ?? null
  isVisible.value = true
  log('PegOverrideModal', 'openModal', 'Abrindo modal de peg', payload)
}

function closeModal(): void {
  isVisible.value = false
  franquiaId.value = null
}

async function handleSave(): Promise<void> {
  // The form owns validation and the request; the modal only closes on success,
  // so a refused peg keeps the operator's input on screen with the reason.
  await formRef.value?.handleSave()
}

onMounted(() => {
  eventBus.on('modal.pegOverride.open', openModal)
})

onBeforeUnmount(() => {
  eventBus.off('modal.pegOverride.open', openModal)
})
</script>
